<template>
  <div class="longtermmakeup">
    <BaseTitle titleText="補長照單" />
    <LongTermInitForm
      :deliveryMethodOptions="deliveryMethodOptions"
      :serviceOptions="serviceOptions"
      :orderData="orderData"
      :usersSearchResult="usersSearchResult"
      :userDetailSearchResult="userDetailSearchResult"
      :orderUserLocation="orderUserLocation"
      :userHistoryAddress="userHistoryAddress"
      :orderDriverIDSearchResult="orderDriverIDSearchResult"
      :orderLicenseNumberSearchResult="orderLicenseNumberSearchResult"
      :driverIsRequired="true"
      @orderDataHandler="orderDataHandler"
      @getUserOrderData="getUserOrderData"
      @inputOnLocation="inputOnLocation"
      @inputOffLocation="inputOffLocation"
      @searchDriverId="searchDriverId"
      @searchLicenseNumber="searchLicenseNumber"
      @selectDriverId="selectDriverId"
      @selectLicenseNumber="selectLicenseNumber"
      @onSubmit="onSubmit"
      @onReset="onReset"
    >
      <section slot="addition" class="longtermmakeup__addition">
        <section v-if="userInfoShow">
          <FormTitle titleText="用戶資訊" />
          <BaseSelect
            labelText="*區域類型"
            :value="user.areaType"
            :text="areaTypeMap(user.areaType)"
            :options="areaTypeOptions"
            :required="true"
            @select="orderDataHandler({ value: $event, property: 'areaType' })"
            class="longtermmakeup__field widerlabel"
          />
          <BaseSelect
            labelText="*身份別"
            :value="user.class"
            :text="classMap(user.class)"
            :options="classOptions"
            :required="true"
            @select="orderDataHandler({ value: $event, property: 'class' })"
            class="longtermmakeup__field widerlabel"
          />
        </section>
        <FormTitle titleText="費用資訊" />
        <InputGroupFare
          :subsidyMethodOptions="subsidyMethodOptions"
          :subsidyMethod="orderData.subsidyMethod"
          :milage="orderData.milage"
          :metreFare="orderData.metreFare"
          :subsidyFare="orderData.subsidyFare"
          :actualFare="orderData.actualFare"
          :autoCountButtonShow="autoCountButtonShow"
          @selectSubsidyMethod="selectSubsidyMethod"
          @inputMilage="inputMilage"
          @inputMetreFare="inputMetreFare"
          @inputSubsidyFare="inputSubsidyFare"
          @inputActualFare="inputActualFare"
          @autoCountMetreFare="autoCountMetreFare"
          class="widerlabel"
        />
      </section>
    </LongTermInitForm>

    <BaseModal id="nextActionModal" @onOk="$router.go(-1)">
      <p slot="modal-content">長照單補單成功，是否返回上一頁？</p>
    </BaseModal>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import BaseSelect from '@/components/base/BaseSelect';
import FormTitle from '@/components/commen/FormTitle';
import LongTermInitForm from '@/components/longTerm/LongTermInitForm';
import InputGroupFare from '@/components/longTerm/InputGroupFare';
import BaseModal from '@/components/base/BaseModal';

import { mapGetters, mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';
import { classMap, areaTypeMap } from '@/utils/optionMaps';

export default {
  name: 'LongTermMakeUp',
  components: {
    BaseTitle,
    BaseSelect,
    FormTitle,
    LongTermInitForm,
    InputGroupFare,
    BaseModal
  },
  data() {
    return {
      showOrderUserData: false,
      orderUserLocation: {},
      userInfoShow: false,
      autoCounted: false
    };
  },
  methods: {
    ...mapActions({
      addOrderMakeup: 'longTerm/addOrderMakeup',
      fetchUserDetailSearch: 'longTerm/fetchUserDetailSearch',
      fetchOrderDriverSearch: 'longTerm/fetchOrderDriverSearch',
      fetchOrderAutoCountMetreFare: 'longTerm/fetchOrderAutoCountMetreFare',
      fetchUser: 'longTerm/fetchUser'
    }),
    classMap(value) {
      return classMap(value);
    },
    areaTypeMap(value) {
      return areaTypeMap(value);
    },
    orderDataHandler({ value, property }) {
      console.log(value, property);
      const data = this.orderData;
      data[property] = value;
      this.$store.commit('longTerm/orderData', data);
    },
    async getUserOrderData(user) {
      await this.fetchUserDetailSearch(user.id);
      await this.fetchUser(user.id);
      this.userInfoShow = true;
      this.orderUserLocation = {
        address: user.address,
        longitude: user.addressGps[0],
        latitude: user.addressGps[1]
      };
      this.$store.commit('longTerm/usersSearchResult', []);
    },
    inputOnLocation(location) {
      const onLocationGps =
        location.longitude && location.latitude
          ? [location.longitude, location.latitude]
          : [];
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        onLocation: location.address,
        onLocationGps: onLocationGps
      });
    },
    inputOffLocation(location) {
      const offLocationGps =
        location.longitude && location.latitude
          ? [location.longitude, location.latitude]
          : [];
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        offLocation: location.address,
        offLocationGps: offLocationGps
      });
    },
    searchDriverId(value) {
      this.fetchOrderDriverSearch({
        dataType: 'driverId',
        driverData: {
          call_number: value
        }
      });
    },
    searchLicenseNumber(value) {
      this.fetchOrderDriverSearch({
        dataType: 'licenseNumber',
        driverData: {
          license_number: value
        }
      });
    },
    selectDriverId(item) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        driverId: item.id,
        licenseNumber: item.licenseNumber
      });
    },
    selectLicenseNumber(item) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        licenseNumber: item.licenseNumber
      });
    },
    selectSubsidyMethod(value) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        subsidyMethod: value
      });
    },
    inputMilage(value) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        milage: value
      });
    },
    inputMetreFare(value) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        metreFare: value
      });
    },
    inputSubsidyFare(value) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        subsidyFare: value
      });
    },
    inputActualFare(value) {
      this.$store.commit('longTerm/orderData', {
        ...this.orderData,
        actualFare: value
      });
    },
    async autoCountMetreFare() {
      try {
        await this.fetchOrderAutoCountMetreFare({
          longTermCareUserId: this.orderData.longTermCareUserId,
          fareData: {
            subsidy_method: this.orderData.subsidyMethod,
            metre_fare: this.orderData.metreFare,
            time: this.orderData.estimateGetOnTime
          }
        });
        this.autoCounted = true;
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    orderDataProcess(data) {
      return Object.keys(data).reduce((accu, curr) => {
        if (curr === 'onLocationGps' && !data[curr].length) return accu;
        if (curr === 'offLocationGps' && !data[curr].length) return accu;
        accu[curr] = data[curr];
        return accu;
      }, {});
    },
    async onSubmit() {
      const data = this.orderDataProcess(this.orderData);
      // 如果沒有計算金額就不得補長照單
      if (!this.autoCounted) {
        this.$store.commit('errorMessage', '需計算費用才可送出');
        this.$root.$emit('bv::show::modal', 'error-modal');
        return;
      }
      try {
        await this.addOrderMakeup(data);
        // this.resetForm();
        this.$bvToast.toast('長照單補單成功', {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        });
        this.$router.go(-1);
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    onReset() {
      this.$router.go(-1);
    },
    resetForm() {
      this.$store.commit('longTerm/orderData', {
        longTermCareUserId: '',
        deliveryMethod: null,
        estimateGetOnTime: '',
        getOnTime: '',
        getOffTime: '',
        onLocation: '',
        onLocationGps: [],
        offLocation: '',
        offLocationGps: [],
        seat: 3,
        service: [],
        serviceNote: '',
        driverId: '',
        licenseNumber: '',
        subsidyMethod: null,
        milage: 0,
        metreFare: 0,
        subsidyFare: 0,
        actualFare: 0
      });
      this.$store.commit('longTerm/userHistoryAddress', []);
    }
  },
  computed: {
    ...mapGetters({
      areaTypeOptions: 'longTerm/areaTypeOptions',
      classOptions: 'longTerm/classOptions',
      user: 'longTerm/user',
      deliveryMethodOptions: 'longTerm/deliveryMethodOptions',
      serviceOptions: 'longTerm/serviceOptions',
      subsidyMethodOptions: 'longTerm/subsidyMethodOptions',
      orderData: 'longTerm/orderData',
      usersSearchResult: 'longTerm/usersSearchResult',
      userDetailSearchResult: 'longTerm/userDetailSearchResult',
      orderDriverIDSearchResult: 'longTerm/orderDriverIDSearchResult',
      orderLicenseNumberSearchResult: 'longTerm/orderLicenseNumberSearchResult',
      userHistoryAddress: 'longTerm/userHistoryAddress'
    }),
    autoCountButtonShow() {
      const {
        subsidyMethod,
        longTermCareUserId,
        metreFare,
        estimateGetOnTime
      } = this.orderData;
      return !(
        longTermCareUserId &&
        subsidyMethod !== null &&
        metreFare &&
        estimateGetOnTime
      );
    }
  },
  beforeRouteLeave(_to, _from, next) {
    this.resetForm();
    next();
  }
};
</script>

<style lang="scss" scoped>
.longtermmakeup {
  width: 65%;
  max-width: 950px;
  margin: 0 auto;

  &__addition {
    margin-top: 30px;
  }

  &__field {
    padding: 20px 80px;
    border-bottom: 1px solid #ededed;
    &:last-child {
      border-bottom: 0;
      margin-bottom: 20px;
    }
  }
}
</style>
